<template>
	<div data-tour-scope="ecommerce-authentication">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title>
								{{ this.$vuetify.lang.t('$vuetify.front.ecommerce.authentication') }}
							</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>
							<v-spacer></v-spacer>
						</v-toolbar>


						<v-data-table
							:headers="headers"
							:options.sync="settings.options"
							:server-items-length="total"
							class="elevation-0 cellanowrap"
							:hide-default-header="isMobile || mobileCards"
							:class="{ mobile: isMobile, 'table-cards': mobileCards }"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="item._id"
							data-tour="table"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni provider diventa una card, la configurazione si apre dentro la card -->
								<tbody v-if="mobileCards" class="auth-cards">
									<tr v-for="p in providerCard" :key="p.indice">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card>
												<template v-slot:title>
													<span class="d-inline-flex align-center">
														<v-avatar v-if="p.logo" size="24px" tile class="mr-2"><img :src="p.logo" alt="" /></v-avatar>
														<v-icon v-else class="mr-2">{{ p.icona }}</v-icon>
														{{ p.nome }}
													</span>
												</template>
												<template v-slot:actions>
													<v-switch
														v-model="p.servizio.active"
														:data-tour="p.tourSwitch"
														@change="saveSetting(p.indice)"
														color="primary"
														v-if="p.servizio"
														class="mt-0 pt-0 mr-2"
														hide-details
													></v-switch>
													<v-btn small icon color="primary" :data-tour="p.tourEspandi" :title="checkpresenza(p.indice) ? 'Chiudi' : 'Configura'" @click="extension(p.indice)">
														<v-icon>{{ checkpresenza(p.indice) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
													</v-btn>
												</template>
												<template v-slot:top>
													<v-chip x-small label :color="configurato(p) ? 'success' : 'warning'" outlined>{{ statoConfigurazione(p) }}</v-chip>
												</template>
												<AuthProviderDetail v-if="checkpresenza(p.indice)" :provider="p" :primo="p.indice === 0" class="mt-2" @salva="saveSetting(p.indice)" @verifica="openConnectionCheck" />
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<template v-for="p in providerCard">
										<tr :key="p.indice">
											<td style="width: 48px">
												<v-btn small icon color="primary" :data-tour="p.tourEspandi" :title="checkpresenza(p.indice) ? 'Chiudi' : 'Configura'" @click="extension(p.indice)">
													<v-icon>{{ checkpresenza(p.indice) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
												</v-btn>
											</td>
											<td>
												<div class="d-flex align-center">
													<v-avatar v-if="p.logo" size="28px" tile class="mr-2"><img :src="p.logo" alt="" /></v-avatar>
													<v-icon v-else class="mr-2">{{ p.icona }}</v-icon>
													<span class="font-weight-medium">{{ p.nome }}</span>
												</div>
											</td>
											<td>
												<v-chip x-small label :color="configurato(p) ? 'success' : 'warning'" outlined>{{ statoConfigurazione(p) }}</v-chip>
											</td>
											<td>
												<v-switch v-model="p.servizio.active" :data-tour="p.tourSwitch" @change="saveSetting(p.indice)" color="primary" v-if="p.servizio" class="mt-0" hide-details></v-switch>
											</td>
										</tr>
										<tr v-if="checkpresenza(p.indice)" :key="p.indice + '-detail'" class="auth-expanded">
											<td :colspan="headers.length" class="py-3">
												<AuthProviderDetail :provider="p" :primo="p.indice === 0" @salva="saveSetting(p.indice)" @verifica="openConnectionCheck" />
											</td>
										</tr>
									</template>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Close</v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>
		<TourOverlay :tour="tour"></TourOverlay>
		<marketplace-connection-check v-model="connectionCheck.open" :service="connectionCheck.service"></marketplace-connection-check>
	</div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { uuid } from 'vue-uuid';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createAuthenticationTourSteps, stopAuthenticationTour } from './authentication-tour';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import AuthProviderDetail from '@/components/ecommerce/authentication/AuthProviderDetail.vue';
import MarketplaceConnectionCheck from '@/views/setting/components/MarketplaceConnectionCheck.vue';
export default {
	name: 'ApiAuth',
	setup() {
		return { tour: useTour(createAuthenticationTourSteps(), { onStop: stopAuthenticationTour }) };
	},
	data() {
		return {
			items: [],
			fees: ['', 'Fisso', 'Percentuale'],
			setinterval: '',
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca
			settings: {
				search: '',
				filters: {
					status: [],
					platform: [],
					created_at: [],
					payments: [],
				},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			},

			listSize: [15, 25, 50, 100],
			linkdownload: '',
			searchfield: '',
			selected: [],
			// verifica connessione: verifica le impostazioni salvate
			connectionCheck: { open: false, service: 'googleauth' },
			selectedchecbox: [],
			selectedall: [],
			total: 0,
			expanded: [],
			singleExpand: false,
			headers: [
				{ text: '', sortable: false },
				{ text: 'Piattaforma', sortable: false },
				{ text: 'Configurazione', sortable: false },
				{ text: 'Attivo sul sito', sortable: false },
			],
			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,

			dialogconfirm: false,

			isActive: true,

			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},
			file: null,
			translateSetting: false,
			isMobile: false,

			googleauth: {
				active: false,
				setting: {
					ClientID: '',
					ClientSecret: '',
					ProjectID: '',
				},
				service: 'googleauth',
				type: 'authentication',
			},
			amazonauth: {
				active: false,
				setting: {
					ClientID: '',
					ClientSecret: '',
				},
				service: 'amazonauth',
				type: 'authentication',
			},
			facebookauth: {
				active: false,
				setting: {
					AppID: '',
					ClientSecret: '',
				},
				service: 'facebookauth',
				type: 'authentication',
			},
			appleauth: {
				active: false,
				setting: {
					ClientID: '',
					TeamID: '',
					KeyID: '',
					PrivateKey: '',
				},
				service: 'appleauth',
				type: 'authentication',
			},
		};
	},
	filters: {
		fixed: function (value) {
			if (!+value) return '';
			return _.round(value, 2);
		},
	},
	async mounted() {
		this.setPreload(true);
		let promises = [];
		promises.push(this.fetchSettings());

		const lists = ['googleauth', 'facebookauth', 'amazonauth', 'appleauth'];

		promises.push(this.fetchService(lists));
		const results = await Promise.all(promises);
		const settings = results[0];

		const langDefault = settings.languages.find(el => el.default === true).lang; //.find({ default: true }).lang;

		settings.languages.sort((a, b) => {
			return (b.default === true) - (a.default === true);
		});

		settings.languages = settings.languages.filter(el => el.is_active === true);
		const transLanguageEmpty = [];
		for (const lang of settings.languages) {
			transLanguageEmpty.push({
				lang: lang.lang,
				text: '',
			});
		}
		let translate = _.find(this.getServices, { service: 'googletranslate' });
		if (translate) {
			this.translateSetting = translate.active;
		}

		this.setPreload(false);
		this.selectedchecbox = [];
		this.selectedall = [];

		const googleauth = _.find(this.getServices, set => {
			return set.service === 'googleauth';
		});
		if (googleauth) {
			this.googleauth = googleauth;
		}
		const facebookauth = _.find(this.getServices, set => {
			return set.service === 'facebookauth';
		});
		if (facebookauth) {
			this.facebookauth = facebookauth;
		}

		const amazonauth = _.find(this.getServices, set => {
			return set.service === 'amazonauth';
		});
		if (amazonauth) {
			this.amazonauth = amazonauth;
		}

		const appleauth = _.find(this.getServices, set => {
			return set.service === 'appleauth';
		});
		if (appleauth) {
			this.appleauth = appleauth;
		}
	},

	watch: {
		settings: {},
	},
	components: {
		TourOverlay,
		KeyValueCard,
		AuthProviderDetail,
		MarketplaceConnectionCheck,
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		// provider per la vista card: stesso indice usato da saveSetting/extension/checkpresenza
		providerCard() {
			return [
				{
					indice: 0,
					nome: 'Google',
					connessione: 'googleauth',
					logo: require('@/assets/images/payments/googlepay.svg'),
					servizio: this.googleauth,
					tourEspandi: 'expand-google',
					tourSwitch: 'switch',
					istruzioni: "Nella console Google Cloud, fra le credenziali OAuth 2.0 dell'app, aggiungi questo indirizzo agli URI di reindirizzamento autorizzati:",
					url: 'https://api.azseller.app/api/v1/nocors/auth/google',
					console: 'https://console.cloud.google.com/apis/credentials',
					campi: [
						{ key: 'ClientID', label: 'Client ID' },
						{ key: 'ClientSecret', label: 'Client Secret', segreto: true },
						{ key: 'ProjectID', label: 'Project ID' },
					],
				},
				{
					indice: 1,
					nome: 'Facebook',
					connessione: 'facebookauth',
					logo: require('@/assets/images/auth/facebook-3.svg'),
					servizio: this.facebookauth,
					istruzioni: "Nell'app su Meta for Developers, in Allowed Origins, aggiungi questo indirizzo:",
					url: 'https://api.azseller.app/api/v1/nocors/auth/facebook',
					console: 'https://developers.facebook.com/apps',
					campi: [
						{ key: 'AppID', label: 'App ID' },
						{ key: 'ClientSecret', label: 'Client Secret', segreto: true },
					],
				},
				{
					indice: 2,
					nome: 'Amazon',
					connessione: 'amazonauth',
					logo: require('@/assets/images/marketplace/Amazon.svg'),
					servizio: this.amazonauth,
					istruzioni: 'Nel profilo di sicurezza di Login with Amazon, in "Allowed Return URLs", aggiungi questo indirizzo:',
					url: 'https://api.azseller.app/api/v1/nocors/auth/amazon',
					console: 'https://developer.amazon.com/loginwithamazon/console/site/lwa/overview.html',
					campi: [
						{ key: 'ClientID', label: 'Client ID' },
						{ key: 'ClientSecret', label: 'Client Secret', segreto: true },
					],
				},
				{
					indice: 3,
					nome: 'Apple',
					connessione: 'appleauth',
					icona: 'mdi-apple',
					servizio: this.appleauth,
					tourEspandi: 'expand-apple',
					istruzioni: 'Nel Services ID su Apple Developer, in "Return URLs", aggiungi questo indirizzo:',
					url: 'https://api.azseller.app/api/v1/nocors/auth/apple',
					nota: 'Il Client ID è il Services ID creato su Apple Developer (es. com.tuaazienda.web).',
					console: 'https://developer.apple.com/account/resources/identifiers/list/serviceId',
					campi: [
						{ key: 'ClientID', label: 'Client ID (Services ID)' },
						{ key: 'TeamID', label: 'Team ID' },
						{ key: 'KeyID', label: 'Key ID' },
						{ key: 'PrivateKey', label: 'Private Key (contenuto del file .p8)', textarea: true, segreto: true },
					],
				},
			];
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getId: 'profile/getId',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getSettings: 'settings/getSetting',
			getDrawerFilter: 'settings/getDrawerFilter',

			getServices: 'services/getServices',
		}),
	},

	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',
			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchSettings: 'settings/asyncFetchData',
			fetchService: 'services/getServiceFetch',

			destroyData: 'settings/destroyData',
			setSettings: 'settings/updateData',
			setService: 'services/updateData',
		}),

		onResize() {
			this.isMobile = window.innerWidth < 769;
		},

		saveSetting(item) {
			let payload;
			switch (item) {
				case 0:
					payload = this.googleauth;
					this.setPreload(true);
					break;
				case 1:
					payload = this.facebookauth;
					this.setPreload(true);
					break;
				case 2:
					payload = this.amazonauth;
					this.setPreload(true);
					break;
				case 3:
					payload = this.appleauth;
					this.setPreload(true);
					break;
			}
			let url = 'services/update';
			axios
				.post(`${this.getUrl}${url}`, payload, {
					headers: { Authorization: `Bearer ${this.getToken}` },
				})
				.then(({ data }) => {
					this.setService(data.data);
					this.setPreload(false);
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.setPreload(false);
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		extension(item) {
			let check = this.selected.includes(item);
			if (!check) {
				this.selected.push(item);
			} else {
				let index = this.selected.indexOf(item);
				this.selected.splice(index, 1);
			}
		},
		openConnectionCheck(service) {
			this.connectionCheck.service = service;
			this.connectionCheck.open = true;
		},
		checkpresenza(item) {
			return this.selected.includes(item);
		},
		compilati(p) {
			const s = (p.servizio && p.servizio.setting) || {};
			return p.campi.filter(c => String(s[c.key] || '').trim()).length;
		},
		configurato(p) {
			return this.compilati(p) === p.campi.length;
		},
		statoConfigurazione(p) {
			const n = this.compilati(p);
			if (n === p.campi.length) return 'Configurato';
			return n ? `Da completare (${n}/${p.campi.length})` : 'Da configurare';
		},
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},
};
</script>

<style></style>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.auth-cards,
.auth-cards tr {
	display: block;
	width: 100%;
}
.auth-cards tr,
.auth-cards tr:hover {
	background: transparent !important;
}
.auth-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.auth-cards tr:first-child td {
	padding-top: 12px !important;
}
.auth-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.auth-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
.auth-expanded,
.auth-expanded:hover {
	background: transparent !important;
}
</style>
